import {
  getAnimateActorAnimationId,
  IAnimateActor,
} from "../../../models/AnimateActor";
import Interaction from "../../../models/interactions/Interaction";
import { useAnimationDetails } from "./useAnimationAssets.hook";

/** Loads (and caches) the API details for an AnimateActor's animation by id. */
export default function useAnimateActorAnimationDetails(
  overrideInteraction?: Interaction
) {
  const interaction = overrideInteraction as IAnimateActor | undefined;
  return useAnimationDetails(
    getAnimateActorAnimationId(interaction?.animation) || undefined
  );
}
